import * as types from './types'
import NotificationsResource from '@/common/resources/Notifications'

export const actions = {
	fetchNotifications ({ commit }, user) {
		return new Promise((resolve, reject) => {
			NotificationsResource.getNotifications(user.id).then((notifications) => {
				commit(types.FETCH_NOTIFICATIONS, { notifications })
				resolve()
			}).catch((e) => {
				reject(e)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Notifications/actions.js